import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import './AuthWrapper.css';

interface AuthWrapperProps {
  children: React.ReactNode;
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  return (
    <Authenticator
      hideSignUp={true}
      formFields={{
        signIn: {
          username: {
            placeholder: 'Enter your email address'
          },
          password: {
            placeholder: 'Enter your password'
          }
        }
      }}
      components={{
        Header() {
          return (
            <div className="auth-header">
              <h2>Crypto Trading System</h2>
              <p>Please sign in to access the trading dashboard</p>
              <p className="admin-notice">Account creation is restricted to administrators</p>
            </div>
          );
        },
        Footer() {
          return (
            <div className="auth-footer">
              <p>Cooter Capital - Authorized Access Only</p>
            </div>
          );
        }
      }}
    >
      {children}
    </Authenticator>
  );
};

export default AuthWrapper;
